import React from "react";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import "../assets/css/ServiceStyle.css";

export default function Service1({ data }) {
  const navigate = useNavigate();

  const handleNavigation = (link) => {
    if (link) navigate(link);
  };

  return (
    <div className="bg-orange-50">
      <div className="container mx-auto pt-20 pb-28" id="part3">
        <Fade direction="right" triggerOnce>
          <h1
            className="text-5xl text-orange-600 text-center font-bold"
            id="part2"
          >
            Our Companies
          </h1>
        </Fade>
        <Fade direction="left" triggerOnce>
          <p className="font-light text-lg text-gray-600 text-center mb-12">
            Here are our three companies
          </p>
        </Fade>

        <div className="grid grid-rows-3 px-10 gap-8 sm:grid-cols-3 sm:grid-rows-1 sm:gap-6 xl:gap-16">
          {data.map((item, index) => (
            <Fade
              direction={item.animation}
              delay={500 * index}
              key={index}
              triggerOnce
            >
              <div
                className="service-card"
                onClick={() => handleNavigation(item.link)}
                style={{ cursor: item.link ? "pointer" : "default" }}
              >
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="service-image"
                />
                <h2 className="service-title text-orange-600">{item.title}</h2>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </div>
  );
}
